// extracted by mini-css-extract-plugin
export default {"productGrid":"ZZ-z","centerLink":"_Z-z","productSection":"a0-z","item":"b0-z","ctaButton":"c0-z"};